// Přistání po přihlášení (08 §5.4 bod 5): jednou za relaci prohlížeče přesměrovat z Domů na
// přistávací sekci role (řidič → Můj den…). Značka v sessionStorage, aby další klik na Domů
// zůstal na Domů; při odhlášení se maže.
const PREDPONA = 'ecoser.pristani.';

function klic(zamestnanecId: string): string {
  return `${PREDPONA}${zamestnanecId}`;
}

/**
 * Vrátí true, když se přistání pro tohoto uživatele ještě neprovedlo. Jen čte, takže ho lze volat
 * opakovaně — React ve vývojovém režimu (StrictMode) volá inicializátor stavu dvakrát a dřívější
 * „přečti a hned označ“ při druhém volání přistání zrušilo (padající e2e v CI, 13. 9. 2026).
 */
export function pristaniCeka(zamestnanecId: string): boolean {
  try {
    return !window.sessionStorage.getItem(klic(zamestnanecId));
  } catch {
    return false;
  }
}

/** Označí přistání za provedené — volat až po vykreslení přesměrování (v efektu), nikdy při renderu. */
export function oznacitPristani(zamestnanecId: string) {
  try {
    window.sessionStorage.setItem(klic(zamestnanecId), '1');
  } catch {
    // sessionStorage nedostupné — přistání se jen zopakuje při dalším příchodu na Domů.
  }
}

/** Po odhlášení: příští přihlášení má zase přistát podle role. */
export function zapomenoutPristani() {
  try {
    const klice: string[] = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const k = window.sessionStorage.key(i);
      if (k?.startsWith(PREDPONA)) klice.push(k);
    }
    klice.forEach((k) => window.sessionStorage.removeItem(k));
  } catch {
    // sessionStorage nedostupné — není co mazat.
  }
}

/** Cesta, na kterou se na tomhle zařízení naposledy přistávalo (localStorage — platí i pro další spuštění). */
const POSLEDNI_PRISTANI = 'ecoser.posledniPristani';

/**
 * Zapamatuje si cíl přistání na tomhle zařízení: při dalším spuštění na Domů (tablet řidiče → Můj den) se kód
 * obrazovky začne stahovat hned, souběžně s ověřením přihlášení (sekce/StrankaSekce.tsx `predNacistPriStartu`).
 */
export function zapamatovatPristani(cesta: string) {
  try {
    window.localStorage.setItem(POSLEDNI_PRISTANI, cesta);
  } catch {
    // localStorage nedostupné — kód obrazovky se jen stáhne až při přistání.
  }
}

/**
 * Kam se asi přistane: cesta z minulého přistání na tomhle zařízení, pokud se v téhle relaci prohlížeče ještě
 * nepřistávalo (nové spuštění aplikace). Uživatel se pozná až z /ja, proto jen odhad podle zařízení.
 */
export function ocekavanePristani(): string | null {
  try {
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      if (window.sessionStorage.key(i)?.startsWith(PREDPONA)) return null;
    }
    return window.localStorage.getItem(POSLEDNI_PRISTANI);
  } catch {
    return null;
  }
}
